// @flow
import { forwardRef } from "react";
import { NumericFormat } from "react-number-format";
import { TextInput } from "./TextInput/TextInput";

type Props = {|
  "data-test"?: string,
  className?: string,
  label?: string,
  onChange(value: number): void,
  placeholder?: string,
  value: ?number,
  hasErrors?: ?boolean,
  errorMessage?: string,
|};

export const CurrencyInput = forwardRef<Props, *>(
  ({ className, label, onChange, placeholder, value, ...rest }, ref) => (
    <NumericFormat
      allowNegative={false}
      className={className}
      customInput={TextInput}
      decimalScale={0}
      label={label}
      onValueChange={({ floatValue }) => onChange(floatValue)}
      placeholder={placeholder}
      prefix="£"
      getInputRef={ref}
      thousandSeparator
      value={value}
      {...rest}
    />
  ),
);
